const flixmediaScriptID = 'flixmedia-script';
export const removeFlixmediaScript = () => {
  const flixmediaScript = document.getElementById(flixmediaScriptID);
  if (flixmediaScript) {
    flixmediaScript.remove();
  }
};

export const addFlixmediaScript = (
  language: string | undefined,
  distributorId: number | undefined,
  ean: string,
  brandname: string | undefined,
) => {
  const flixmediaScript = document.getElementById(flixmediaScriptID);
  if (!flixmediaScript && distributorId) {
    const script = document.createElement('script');
    script.setAttribute('src', '//media.flixfacts.com/js/loader.js');
    script.setAttribute('data-flix-distributor', distributorId.toString());
    script.setAttribute('data-flix-language', language && language === 'fr' ? 's5' : 's4');
    script.setAttribute('data-flix-brand', brandname || '');
    script.setAttribute('data-flix-ean', ean);
    script.setAttribute('data-flix-inpage', 'flix-inpage');
    script.setAttribute('data-flix-fallback-language', 'de');
    script.setAttribute('data-flix-autoload', 'inpage');
    script.setAttribute('id', flixmediaScriptID);
    document.head.insertBefore(script, document.head.firstElementChild);
  }
};
